<div
  class="card"
  *appIsGranted="['PACKETS_COMMANDS', 'PACKETS_COMMANDS', 'READ']"
>
  <div class="card-body column">
    <div class="row">
      <h6 class="card">Pesquisa de Comandos</h6>
      <div class="col-md-4">
        <div class="column">
          <label for="serial" class="col-md-2 col-form-label">Seriais</label>
          <input
            class="input w-75"
            placeholder="205502151; ..."
            [(ngModel)]="seriais"
            [ngbTooltip]="seriais.split(';').join('; ')"
          />
          <p *ngIf="mensagemErro" class="text-center">
            {{ mensagemErro }}
          </p>
        </div>
      </div>
      <div class="col-md-4">
        <div class="row justify-content-end">
          <div>
            <label
              _ngcontent-tsb-c236=""
              for="startDate"
              class="col-md-4 col-form-label"
              >Data inicial</label
            >
            <input type="datetime-local" step="1" [(ngModel)]="dateStart" />
          </div>
          <div>
            <label
              _ngcontent-tsb-c236=""
              for="endDate"
              class="col-md-4 col-form-label"
              >Data Final</label
            >
            <input type="datetime-local" step="1" [(ngModel)]="dateEnd" />
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <div class="column">
          <div>
            <button
              *appIsGranted="['PACKETS_COMMANDS', 'PACKETS_COMMANDS', 'READ']"
              type="button"
              class="btn btn-primary btn-sm mb-2"
              (click)="searchCommands(seriais.split(';'))"
            >
              Pesquisar
            </button>
          </div>
          <div class="dropdown mt-1" ngbDropdown>
            <button
              class="btn btn-sm btn-primary dropdown-toggle"
              type="button"
              id="dropdownMenuButton"
              data-bs-toggle="dropdown"
              aria-haspopup="true"
              aria-expanded="false"
              ngbDropdownToggle
            >
              Ações <i class="mdi mdi-chevron-down"></i>
            </button>
            <div
              class="dropdown-menu"
              aria-labelledby="dropdownMenuButton"
              ngbDropdownMenu
            >
              <a class="btn dropdown-item" (click)="exportExcel()"
                >Exportar Excel</a
              >
            </div>
          </div>
        </div>
      </div>
      <div class="col-md-2">
        <button
          *appIsGranted="['PACKETS_COMMANDS', 'PACKETS_COMMANDS', 'CREATE']"
          type="button"
          class="btn btn-primary btn-sm"
          (click)="openModalCommandCustom(modalCommand)"
          style="background-color: green"
          ngbTooltip="Novo Comando"
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            width="16"
            height="16"
            fill="currentColor"
            class="bi bi-command"
            viewBox="0 0 16 16"
          >
            <path
              d="M3.5 2A1.5 1.5 0 0 1 5 3.5V5H3.5a1.5 1.5 0 1 1 0-3zM6 5V3.5A2.5 2.5 0 1 0 3.5 6H5v4H3.5A2.5 2.5 0 1 0 6 12.5V11h4v1.5a2.5 2.5 0 1 0 2.5-2.5H11V6h1.5A2.5 2.5 0 1 0 10 3.5V5H6zm4 1v4H6V6h4zm1-1V3.5A1.5 1.5 0 1 1 12.5 5H11zm0 6h1.5a1.5 1.5 0 1 1-1.5 1.5V11zm-6 0v1.5A1.5 1.5 0 1 1 3.5 11H5z"
            />
          </svg>
          Novo Comando
        </button>
      </div>
    </div>
  </div>
</div>
<!-- end card body -->

<div class="card align-items-center" *ngIf="circularProgressiveWait">
  <div card="card-body">
    <div class="spinner-border text-primary m-1" role="status">
      <span class="sr-only">Loading...</span>
    </div>
  </div>
</div>
<div *ngIf="!circularProgressiveWait">
  <div [fluidHeight] class="mt-n4">
    <div class="card-body">
      <table class="table table-fit table-bordered table-hover">
        <thead class="table-primary">
          <tr>
            <th class="col-md-1 text-center" scope="col">
              Id Banco
            </th>
            <th class="col-md-1 text-center" scope="col">
              Solicitacao Comando Id
            </th>
            <th class="col-md-1 text-center" scope="col">Serial</th>
            <th class="col-md-1 text-center" scope="col">
              DataHora Requisicao
            </th>
            <th class="col-md-1 text-center" scope="col">DataHora Envio</th>
            <th class="col-md-1 text-center" scope="col">DataHora Resposta</th>
            <th class="col-md-2 text-center" scope="col">TipoComando</th>
            <th class="col-md-1 text-center" scope="col">Status</th>
            <th class="col-md-5 text-center" scope="col">Comando</th>
          </tr>
        </thead>
        <tbody>
          <tr
            *ngFor="let command of commandResponse; let i = index"
            [ngClass]="commandoStatus.commandStatusColor(command.statusId)"
          >
            <td class="text-center" scope="row">
              {{ command.idDb }}
            </td>
            <td class="text-center" scope="row">
              {{ command.id }} [{{ command.sistema }}]
            </td>
            <td class="text-center" scope="row">
              {{ command.serial }}
            </td>
            <td class="text-center" scope="row">
              {{ command.dataRequisicao }}
            </td>
            <td class="text-center" scope="row">
              {{ command.dataEnvio }}
            </td>
            <td class="text-center" scope="row">
              {{ command.dataResposta }}
            </td>
            <td class="text-center" scope="row">
              {{ commandName[command.comandoTipoId] }}
              <br />
              timeout: {{ returnTimeOutName(command.timeout) }}
              <br />
              <i-feather
                *ngIf="
                  commandStatusEnum[command.statusId] != 'EXECUTADO' ||
                  commandStatusEnum[command.statusId] != 'TIMEOUT' ||
                  commandStatusEnum[command.statusId] != 'CANCELADO'
                "
                ngbTooltip="Cancelar o comando"
                name="trash-2"
                style="color: red"
                (click)="cancelCommand(command.id.toString(), command.sistema)"
              ></i-feather>
            </td>
            <td class="text-center" scope="row">
              {{ commandStatusEnum[command.statusId] }}
            </td>
            <td class="text-center" style="word-break: break-all" scope="row">
              {{ command.resposta }} <br />

              <a
                [ngbTooltip]="command.comando"
                style="cursor: pointer"
                (click)="copyCommand(command.comando)"
                >#
              </a>
              <ng-container
                *ngIf="
                  command.parametros != undefined &&
                  command.parametros != null &&
                  command.comandoTipoId != 1
                "
              >
                - parametro enviado = {{ command.parametros }}
              </ng-container>
            </td>
          </tr>
        </tbody>
      </table>
    </div>
  </div>
</div>

<!-- Dialog comando -->
<ng-template #modalCommand let-modal>
  <div *appIsGranted="['PACKETS_COMMANDS', 'PACKETS_COMMANDS', 'CREATE']">
    <div class="modal-header">
      <h5 class="modal-title mt-0">Novo comando</h5>
      <button
        type="button"
        class="btn btn-close"
        (click)="modal.dismiss('Cross click')"
        aria-hidden="true"
      ></button>
    </div>
    <div class="modal-body">
      <div class="column">
        <div>
          <label
            for="serial"
            class="col-md-1 col-form-label"
            style="margin-right: 20px"
          >
            Serial</label
          >
          <input
            placeholder="205502151;"
            [ngbTooltip]="commandSelect.seriais"
            [(ngModel)]="commandSelect.seriais"
            class="w-75"
          />
        </div>
        <div class="form-group" *ngIf="commandInfoType.length > 0">
          <ng-select
            class="w-100 mb-3"
            id="commandSelect"
            placeholder="Selecione um comando"
            [ngModelOptions]="{ standalone: true }"
            [(ngModel)]="commandSelect.nome"
            (click)="filterCommand(commandSelect.nome)"
          >
            <ng-option *ngFor="let command of commandInfoType">
              {{ command.nome }}
            </ng-option>
          </ng-select>
        </div>
        <div 
          class="form-group" *ngIf="accessoryExists">
          <ng-select 
            class="w-100 mb-3"
            placeholder="Modelo do Acessório"
            [items]="selectAccessory"
            bindLabel="accessoryModel"
            bindValue="accessoryModeloId"
            [(ngModel)]="commandSelect.idAccessory">
          </ng-select>
        </div>
        <div *ngIf="commandSelect.observacaoHTML != ''">
          <span
            class="card font-weight-bold ms-2"
            [innerHTML]="commandSelect.observacaoHTML"
          >
          </span>
        </div>
        <div *ngIf="commandSelect.valor" class="form-group">
          <label>Parâmetros</label>
          <input
            class="input w-75 ms-2"
            [placeholder]="commandSelect.exemplo"
            [(ngModel)]="commandSelect.param"
          />
        </div>

        <div class="row">
          <div class="col-md-8">
            <label class="col-md-2 col-form-label"> Timeout </label>
            <div class="d-inline ms-4">
              <select [(ngModel)]="commandSelect.timeout">
                <option
                  *ngFor="let item of timeOutKeys; let i = index"
                  [value]="i"
                >
                  {{ item }}
                </option>
              </select>
            </div>
          </div>
        </div>
        <ng-container
          *appIsGranted="[
            'PACKETS_COMMANDS',
            'PACKETS_COMMANDS_DIRECT',
            'CREATE'
          ]"
        >
          <div class="card">
            <div class="row d-flex">
              <div class="col">
                <div *ngIf="commandSelect.comandoId == 1" class="form-group">
                  <label>Forçar envio no gateway</label>
                  <input id="forceSendGateway" type="checkbox" />
                </div>
              </div>
              <div class="col">
                <div *ngIf="commandSelect.comandoId == 1" class="form-group">
                  <label>ASCII</label>
                  <input
                    id="isASCII"
                    type="checkbox"
                    ngbTooltip="Comandos do tipo ASCII deve ser marcado"
                  />
                </div>
              </div>
            </div>
            <div *ngIf="commandSelect.comandoId == 1">
              <span class="text-danger ms-3"
                ><b
                  >Verifica se o dispositivo está conectado e envia direto no
                  gateway, usar caso o dispositivo não esteja com posição
                  recente. Não gera registro no banco e não tem como
                  consultar.</b
                ></span
              >
            </div>
          </div>
        </ng-container>
        <div class="align-middle">
          <button
            class="btn btn-success"
            type="submit"
            (click)="sendCommandDefault(); modal.dismiss()"
            [disabled]="
              commandSelect.seriais.length < 1 ||
              (commandSelect.valor && commandSelect.param.length < 1) ||
              commandSelect.nome == 'Selecione um comando' ||
              commandSelect.nome == ''
            "
          >
            Enviar
          </button>
          <label
            class="text-danger ms-3"
            *ngIf="
              commandSelect.seriais.length < 1 ||
              (commandSelect.valor && commandSelect.param.length < 1)
            "
            >Prencha o serial e o parâmetro(se houver)</label
          >
        </div>
      </div>
    </div>
  </div>
</ng-template>
<!--Fim Dialog comando padrão -->
